import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Blogs() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [status, setStatus] = useState('loading'); // 'loading' | 'ready' | 'error'

  useEffect(() => {
    let cancelled = false;

    axios
      .get('/api/blogs/', { params: { status: 'published' } })
      .then((response) => {
        if (cancelled) return;
        setBlogPosts(response.data?.blogs ?? []);
        setStatus('ready');
      })
      .catch(() => {
        if (cancelled) return;
        setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <div
        className="container-fluid bg-primary py-5 mb-5 hero-header"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.856), rgba(79, 79, 79, 0.801)), url(${process.env.PUBLIC_URL}/assets/img/cover.jpg)`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Blogs
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    Blogs
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Our Blog
            </h6>
            <h1 className="mb-5">Latest Travel Stories & Guides</h1>
          </div>

          {status === 'loading' && (
            <div className="text-center py-5">
              <p className="mb-0">Loading blogs…</p>
            </div>
          )}

          {status === 'error' && (
            <div className="text-center py-5">
              <p className="mb-0">Could not load blogs right now. Please try again later.</p>
            </div>
          )}

          {status === 'ready' && blogPosts.length === 0 && (
            <div className="text-center py-5">
              <p className="mb-0">No blogs are available yet. Check back soon.</p>
            </div>
          )}

          {status === 'ready' && blogPosts.length > 0 && (
            <div className="row g-4">
              {blogPosts.map((post, index) => (
                <div key={post.slug} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 * (index + 1)}s`}>
                  <div className="blog-item rounded overflow-hidden h-100 d-flex flex-column shadow-sm">
                    <div className="position-relative overflow-hidden" style={{ height: 220 }}>
                      <img
                        className="img-fluid w-100 h-100"
                        src={post.image}
                        alt={post.title}
                        style={{ objectFit: 'cover' }}
                      />
                      <div
                        className="position-absolute top-0 start-0 bg-primary text-white px-3 py-1 m-3"
                        style={{ borderRadius: 4, fontSize: '0.8rem' }}
                      >
                        {post.category}
                      </div>
                    </div>
                    <div className="p-4 d-flex flex-column flex-grow-1">
                      <small className="text-muted mb-2">
                        <i className="fa fa-calendar-alt me-2" />
                        {new Date(post.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                      </small>
                      <h5 className="mb-3">{post.title}</h5>
                      <p className="mb-4 flex-grow-1">{post.excerpt}</p>
                      <Link to={`/blogs/${post.slug}?v=1`} className="btn btn-sm btn-primary px-3 align-self-start" style={{ borderRadius: '0 30px 30px 0' }}>
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Blogs
